import React from "react";

export const Types02: React.FC = () => {
  return (
    <div className="types02-section">
      <div className="moreinfo-container">
        <div className="types02-wrapper">
          <div className="types02-left-column">
            <h2 className="moreinfo-title moreinfo-title-blue moreinfo-title-left">Tipos de endo</h2>
            
            <div className="types02-images">
              <img
                src="img/type3.webp"
                className="types02-image"
                alt="Endometrioma"
              />
            </div>
          </div>
          
          <div className="types02-right-column">
            <h2 className="moreinfo-title moreinfo-title-blue moreinfo-title-left types02-title-hidden" aria-hidden="true">Tipos de endo</h2>
            
            <ul className="types01-list">
              <li className="types01-list-item">
                <span className="moreinfo-highlight-blue types01-type-name">ENDOMETRIOMA:</span> Es la endometriosis 
                profunda dentro del ovario. También se conocen como "quistes de chocolate" por su contenido de líquido espeso y 
                oscuro. <strong>Más del 60% de las personas con endometriomas tendrán endometriosis
                en otras partes.</strong> Si un médico te dice que se trata "únicamente" de un endometrioma, sería bueno pedir
                una segunda opinión.
              </li>
            </ul>
            
            <hr className="types02-divider" />
            
            <p className="moreinfo-text">
              Un tema muy importante es la apariencia de las lesiones de endometriosis y los distintos colores que éstas pueden
              presentar. <em>Un estudio evidenció que ⅔ de los pacientes tienen formas de endometriosis que los doctores no
              especializados en el tema no son capaces de reconocer.</em>
            </p>
            
            <p className="moreinfo-text">
              La endometriosis puede ser clara, <span className="types02-color-red">roja</span>, blanca, <span className="types02-color-black">negra</span>, <span className="types02-color-blue">azul</span>, <span className="types02-color-grey">gris</span>, <span className="types02-color-yellow">amarilla</span>. Por ejemplo en pacientes adolescentes y jóvenes es más habitual encontrar lesiones claras o rojas que lesiones negras.
            </p>
            
            <p className="moreinfo-text">
              Una persona de cualquier edad puede tener cualquiera de las diferentes presentaciones de la enfermedad, pero es más
              frecuente que con la edad las lesiones se vayan volviendo más oscuras.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};